{
  "phasePanel": {
    "filesColumnFile": "File",
    "filesColumnDescription": "Description",
    "filesColumnStatus": "Status"
  },
  "tabs": {
    "plan": "Plan",
    "designEffective": "Design effective",
    "operatingEffective": "Operating effective",
    "report": "Report",
    "ariaLabel": "Audit sections"
  },
  "phase": {
    "designEffective": {
      "filesTitle": "Design documentation",
      "runsTitle": "Design-effective runs",
      "runHeading": "Design-effective run {{version}}"
    },
    "operatingEffective": {
      "filesTitle": "Logs and records",
      "runsTitle": "Operating-effective runs",
      "runHeading": "Operating-effective run {{version}}"
    }
  },
  "plan": {
    "title": "Audit plan",
    "meta": "v{{version}} · {{count}} items",
    "approved": "Approved",
    "approve": "Approve plan",
    "approving": "Approving…",
    "approveFailed": "The plan could not be approved. Try again.",
    "approveWarning": "Approving the plan fixes the item list. You will not be able to change it afterwards.",
    "emptyTitle": "No plan yet",
    "emptyHint": "Add a brief or scope documents below, then generate the plan.",
    "loadFailed": "Could not load the plan. Try again.",
    "briefTitle": "Brief (optional)",
    "scopeTitle": "Scope documents",
    "scopeUpload": "Upload scope documents",
    "scopeUploadFailed": "Failed to upload scope documents. Please retry.",
    "scopeDeleteFailed": "Failed to delete the scope document. Please retry.",
    "readbackFailed": "The plan could not be loaded. Please reload to read the saved plan."
  },
  "files": {
    "phaseRunInProgress": "Uploads and changes to {{phase}} evidence are paused while its run is active.",
    "phaseIngestInProgress": "{{phase}} evidence is being ingested. Wait for it to finish before starting this run.",
    "serialPipeline": "Uploads and processing for both phases wait until the current file processing finishes.",

    "count_one": "{{count}} file",
    "count_other": "{{count}} files",
    "reading_one": "{{count}} reading",
    "reading_other": "{{count}} reading",
    "lockedByRun": "You cannot add files while an analysis is running. Add more once it finishes, then run again.",
    "lockedByChecklist": "Approve this tab's checklist to add files."
  },
  "coverage": {
    "title": "Coverage check",
    "explain": "Bennie checks your files against this tab's checklist and tells you what is missing before you run the analysis.",
    "waiting": "Waiting for reading to finish",
    "waitingHint": "You cannot start the analysis while files are being read. It will be available when reading finishes.",
    "checking": "Checking your files",
    "recheck": "Re-check",
    "covered": "{{covered}} of {{total}} items have supporting evidence",
    "advisory": "You can still run the analysis.",
    "unavailable": "No coverage check has run for these files.",
    "loadFailed": "Could not load the coverage check. Try again.",
    "stalled": "The coverage check is taking longer than expected. You can still run the analysis, or re-check later."
  },
  "run": {
    "start": "Run analysis",
    "starting": "Starting…",
    "inProgressHeading": "Analysing items",
    "itemsAnalysed": "{{count}} of {{total}} items analysed",
    "progressUnavailable": "Progress unavailable",
    "startedAt": "Started {{time}}",
    "stage": "Stage",
    "stageUnknown": "Preparing",
    "stageGenerating": "Reading your files",
    "stageExtracting": "Collecting what it found",
    "stageSequencing": "Ordering the findings",
    "stageAggregating": "Grouping the issues",
    "stageChecking": "Checking consistency",
    "stageDone": "Finishing",
    "columnVersion": "Version",
    "columnStarted": "Started",
    "columnStatus": "Status",
    "columnFiles": "Files",
    "columnSummary": "Summary",
    "open": "Open",
    "latest": "Latest",
    "emptyTitle": "No analysis yet",
    "emptyHint": "Add your files, then run the analysis to get a verdict for every checklist item.",
    "loadFailed": "Could not load the analysis history. Try again.",
    "failedSummary": "The analysis could not finish. Try again.",
    "status": {
      "queued": "Queued",
      "running": "Running",
      "completed": "Completed",
      "failed": "Failed"
    },
    "blocked": {
      "ingest_in_progress": "Your files are still being read. Run the analysis once that finishes.",
      "run_in_progress": "An analysis is already running. Wait for it to finish, then run again.",
      "report_in_progress": "A report is being generated. Wait for it to finish, then run again.",
      "plan_not_approved": "Approve the plan first.",
      "workspace_locked": "This audit is locked and cannot be changed.",
      "evidence_not_ingested": "Some of the uploaded files have not been ingested yet. Click Ingest Data, then run the analysis.",
      "evidence_ingest_failed": "A file for this analysis could not be ingested. Remove it or upload it again, click Ingest Data, then run the analysis.",
      "evidence_deletion_incomplete": "A file for this analysis could not be fully removed. Try removing it again, then run the analysis.",
      "generic": "The analysis could not be started. Try again.",
      "audit_phase_checklist_not_approved": "Approve this tab's checklist first."
    },
    "admissionLoading": "Checking whether analysis can start…",
    "admissionFailed": "Could not check whether analysis can start. Refresh and try again."
  },
  "verdict": {
    "Effective": "Effective",
    "EffectiveWithExceptions": "With exceptions",
    "PartiallyEffective": "Partially effective",
    "NotEffective": "Not effective",
    "NotConcluded": "Not concluded",
    "count": "{{count}} {{label}}"
  },
  "runItems": {
    "columnItem": "Checklist item",
    "columnVerdict": "Verdict",
    "columnIssues": "Issues",
    "analysed": "Analysed, checks pending",
    "failed": "Analysis failed",
    "waiting": "Waiting",
    "stateUnavailable": "Item status unavailable",
    "empty": "No checklist items to show.",
    "exportExcel": "Export to Excel",
    "exporting": "Exporting…",
    "exportFailed": "Excel export failed",
    "columnExplanation": "Explanation",
    "loadFailed": "Could not load the checklist for this analysis. Try again.",
    "issueLogHeading": "Issues from this analysis"
  },
  "item": {
    "close": "Close",
    "findingsHeading": "What Bennie found",
    "issuesHeading": "Issues from this item",
    "noBody": "This item has no saved result.",
    "loadFailed": "Could not load this item. Try again.",
    "breadcrumb": "{{phase}} v{{version}} · {{itemId}}",
    "explanationHeading": "Explanation",
    "dataGap": "There was not enough evidence to reach a conclusion on this item.",
    "contextDegraded": "Part of the reference material could not be used when this item was analysed, so the analysis may be incomplete. Re-run the phase to try again.",
    "citedSources": "Cited sources"
  },
  "report": {
    "versionLabel": "Report V{{version}}",
    "current": "Current",
    "generatedAt": "Generated {{time}}",
    "expand": "Show this version",
    "collapse": "Hide this version",
    "generateNew": "Generate a new version",
    "emptyTitle": "No report yet",
    "emptyHint": "Run both analyses first. The report is available once a design-effective run and an operating-effective run have finished.",
    "loadFailed": "Could not load the report versions. Try again.",
    "reingestRequired": "Some of this audit's files could not be read, so the report cannot be rebuilt from them. Restart data ingestion for this audit, then generate the report again.",
    "generateFailed": "The report could not be started. Try again.",
    "emptyHintReady": "Both analyses have finished. Generate a new version to create the report.",
    "statusGenerating": "Generating",
    "statusFailed": "Failed",
    "failed": {
      "report_generation_crashed": "This version could not be generated. Your analyses were not changed. Generate a new version.",
      "report_generation_cancelled": "This version was stopped before it finished. Your analyses were not changed. Generate a new version.",
      "auditing_phase2_entered": "This version was stopped before it could change any analysis results. Nothing was deleted. Generate a new version.",
      "report_version_settle_failed": "This version finished but could not be saved as the current report. Your analyses were not changed. Generate a new version.",
      "report_overarching_failed": "This version could not produce its report-level issues. Your analyses were not changed. Generate a new version.",
      "report_overarching_not_done": "This version finished without its report-level issues, so it was not saved as the current report. Your analyses were not changed. Generate a new version.",
      "report_cohort_park_unreachable": "This version stopped with sections that could not be retried or accepted. Your analyses were not changed. Generate a new version.",
      "generic": "This version could not be generated. Your analyses were not changed. Generate a new version.",
      "halted": "This version stopped because generation is paused by an upstream issue. Your analyses were not changed. Use “{{clearHalt}}” to resume, then generate a new version."
    },
    "blocked": {
      "plan_not_stable": "Approve the plan first.",
      "ingest_in_progress": "Your files are still being read. Generate the report once that finishes.",
      "run_in_progress": "An analysis is still running. Generate the report once it finishes.",
      "report_in_progress": "A report version is already being generated. Wait for it to finish.",
      "report_version_in_progress": "A report version is already being generated. Wait for it to finish.",
      "report_runs_incomplete": "The report needs one finished design-effective analysis and one finished operating-effective analysis. Run whichever is missing, then generate the report.",
      "report_generation_unfinished": "The last report version did not finish. Open it below and use Feedback or Retry from scratch on each section that did not finish, then generate a new version once every section is complete.",
      "generation_in_progress": "A report version is being generated. Wait for it to finish, then generate again."
    },
    "preflightTitle": "Generate a new version",
    "preflightIntro": "The new version is built from these approved checklists and finished analyses.",
    "preflightChecklist": "Checklist v{{version}} · {{count}} items",
    "preflightNoChecklist": "No approved checklist",
    "preflightRun": "Analysis v{{version}} · {{status}}",
    "preflightNoRun": "No finished analysis",
    "preflightCancel": "Cancel",
    "preflightFailed": "Could not load what the new version will use. Try again.",
    "exportExcel": "Export to Excel",
    "exporting": "Exporting…",
    "exportFailed": "Excel export failed",
    "preflightLoading": "Checking report readiness…",
    "sectionsBeingWritten": "Sections are being written.",
    "references": {
      "count_one": "{{count}} document",
      "count_other": "{{count}} documents",
      "location": "Location",
      "content": "Content"
    },
    "issues": {
      "title": "Issue log",
      "count_one": "{{count}} issue",
      "count_other": "{{count}} issues",
      "finding": "Finding"
    }
  },
  "chat": {
    "open": "Ask Bennie",
    "collapse": "Collapse",
    "title": "Ask Bennie",
    "ariaExpand": "Open chat",
    "ariaCollapse": "Close chat",
    "answeringFor": "Answering for {{tab}}"
  },
  "checklist": {
    "titleDe": "Design checklist",
    "titleOe": "Operating checklist",
    "meta": "v{{version}} · {{count}} items",
    "approved": "Approved",
    "approve": "Approve checklist",
    "approving": "Approving…",
    "approveWarning": "Approving the checklist fixes its items. You will not be able to change them afterwards.",
    "loadFailed": "Could not load the checklist. Try again.",
    "loading": "Loading the checklist…",
    "lockedByPlan": "Approve the plan to create the design checklist.",
    "lockedByDe": "Approve the design checklist to create the operating checklist.",
    "generate": "Generate checklist",
    "generating": "Generating…",
    "generatingHint": "This can take a few minutes.",
    "emptyHintDe": "Bennie builds the design checklist from your approved plan.",
    "emptyHintOe": "Bennie builds the operating checklist from your approved design checklist.",
    "edit": "Edit",
    "remove": "Remove",
    "add": "+ Add item",
    "save": "Save",
    "saving": "Saving…",
    "cancel": "Cancel",
    "required": "Required",
    "fieldTitle": "Item",
    "fieldDescription": "What to check",
    "fieldMethod": "How",
    "fieldMethodOptional": "How to check it (optional)",
    "fieldRefs": "Design items this tests",
    "testsDesignItems": "Tests: {{items}}",
    "actionFailed": "That change could not be saved. Try again.",
    "generationStalled": "The checklist is taking longer than expected. Reload the page to check again, or generate it again.",
    "retry": "Try again",
    "generationIncomplete": "The checklist was not generated. Try again."
  },
  "failure": {
    "timedOut": "This is taking longer than expected. Try again.",
    "network": "Could not reach Bennie. Check your connection and try again.",
    "unexpectedResponse": "Bennie returned an unexpected answer. Try again."
  },
  "scrollLines": {
    "goTo": "Go to section {{index}} of {{count}}"
  }
}
